import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
import { BUTTON_HOVER_EVENT_NAME, DOCUMENT_DESCRIPTION_EVENT_NAME, DOCUMENT_INTERACTION_EVENT_NAME, DOCUMENTS_NAMESPACE, FOLDER_INTERACTION_EVENT_NAME, UPLOAD_FILE_EVENT_NAME } from './events';
import { makeUuid } from 'usage-tracker-core/common/helpers';
let tracker;
const uuid = makeUuid();
export const initTracker = ({
  isPublic = false
} = {}) => {
  if (tracker) {
    return tracker;
  }
  const options = {
    standalone: true
  };
  if (isPublic) {
    options.allowUnauthed = true;
    options.properties = {
      deviceId: uuid
    };
  }
  tracker = withSessionReplay(createTracker(options));
  return tracker;
};
export const resetTracker = () => {
  tracker = undefined;
};
export const track = (namespace, event, eventProps = {}) => {
  if (!tracker) {
    throw new Error('Tracker has not been initialized');
  }
  const {
    screen = 'index'
  } = eventProps;
  tracker.track(namespace, event, Object.assign({
    screen
  }, eventProps));
};
export const trackInteraction = (action, screen) => track(DOCUMENTS_NAMESPACE, DOCUMENT_INTERACTION_EVENT_NAME, {
  action,
  screen
});
export const trackFolder = ({
  action,
  screen
}) => {
  track(DOCUMENTS_NAMESPACE, FOLDER_INTERACTION_EVENT_NAME, {
    action,
    screen
  });
};
export const trackHover = ({
  action,
  type,
  screen
}) => track(DOCUMENTS_NAMESPACE, BUTTON_HOVER_EVENT_NAME, {
  action,
  type,
  screen
});
export const trackUpload = ({
  action,
  source,
  screen,
  transport,
  fileSizeBytes,
  partCount,
  retryCount,
  failureClass,
  stage,
  partNumber
}) => track(DOCUMENTS_NAMESPACE, UPLOAD_FILE_EVENT_NAME, {
  action,
  source,
  screen,
  transport,
  fileSizeBytes,
  partCount,
  retryCount,
  failureClass,
  stage,
  partNumber
});
export const trackDescriptionInteraction = ({
  action
}) => track(DOCUMENTS_NAMESPACE, DOCUMENT_DESCRIPTION_EVENT_NAME, {
  action
});